module.exports = __webpack_public_path__ + "static/media/training.afbdf051.png";